'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * @class ShopifyMarketing.Helpers.Cookie
 */
const cookieHelper = {
  /**
   * Return the value for a cookie by the given `key`.
   *
   * @method get
   * @param {string} key Name of the cookie to get.
   * @param {string} cookies Defaults to `document.cookie`
   * @return {string|undefined}
   */
  get: (key, cookies = document.cookie) => {
    const entries = cookies.split(/;\s*/).map(item => item.split('=').map(decodeURIComponent)).reduce((obj, [name, value]) => Object.assign(obj, {
      [name]: value
    }), {});
    return entries[key];
  },

  /**
   * Sets the value of the cookie `key`, given `value`.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toUTCString
   * @method set
   * @param {string} key Name of the cookie to set
   * @param {string} value Value of the cookie to set (will passed `encodeURIComponent`)
   * @param {object} [options={}]
   * @param {string} [options.expires] Set the cookie expiry (in UTC string format)
   * @param {string} [options.path] Set the cookie path
   * @return {string}
   */
  set: (key, value, {
    expires,
    path
  } = {}) => {
    let string = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    string += expires ? `; expires=${expires}` : '';
    string += path ? `; path=${path}` : '';
    string += '; secure';
    document.cookie = string;
    return string;
  }
};

exports.default = cookieHelper;
